import { jsPDF } from "jspdf";
import moment from "moment";
import { defineStore, acceptHMRUpdate } from "pinia";

export const usePDFuknown = defineStore("pdf-unknown", {
  state: () => ({}),
  getters: {},
  actions: {
    downloadPDF(downloadData) {
      const el = document.createElement("div");
      let x = "";
      x = `
      <table>
        <tr>
          <td style="width:500px"></td>
          <td style="font-weight: bold">National Archives of Singapore (NAS)</td>
        </tr>
      </table>
      <table style="margin-bottom: 40px">
        <tr>
          <td style="width:580px"></td>
          <td style="font-weight: bold">Report Summary</td>
        </tr>
      </table>
      <table style="margin-bottom: 40px">
      <tr>
        <td style="width: 200px">Date Received by SDPS</td>
        <td>`;
      x += moment(downloadData.depositedAt).format("DD MMM yyyy | HH:mm:ss");
      x += `</td>
      </tr>
    </table>
    <table>
      <tr>
      The name of transfer package <b> "`;
      x += downloadData.name;
      x += ` "</b>
      is incorrect and the Transfer Outcome is "Failed".
      </tr>
    </table>

    <table style="margin-top: 40px">
      <tr>
        <td>
        Where the Transfer Outcome is "Failed", the Transferring Agency shall refer to the Error Report for a full list of errors and rectify them accordingly. 
        Once errors have been rectified, please schedule a new transfer. 
        Refer to the NAS Records Management website for more detailed transfer requirements and instructions.
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 10px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
          For any enquiries regarding this report, please email to
          NAS_RM@nlb.gov.sg.
        </td>
      </tr>
      <tr>
        <td style="font-style: italic">This is a computer generated report.</td>
      </tr>
    </table>`;

      el.innerHTML = x;
      let doc = new jsPDF({
        orientation: "landscape",
      });
      el.style.width = "1400px";
      el.style.letterSpacing = "1px";

      doc.html(el, {
        callback: function (doc) {
          doc.save("Report Summary_" + downloadData.name + ".pdf");
        },
        x: 4,
        y: 10,
        width: 1400,
        html2canvas: { scale: 0.2 },
      });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePDFuknown, import.meta.hot));
}
